import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, formatMoney, getInlineLoader } from "../Helpers";
import {
	STR_AVAILABLE_HOTELS,
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_CURRENT_BALANCE,
	STR_INVALID_WITHDAWAL_INFO,
	STR_MENU_HOTELS,
	STR_MENU_MY_PURCHASES,
	STR_MY_EARNINGS_HISTORY,
	STR_MY_REVENUES,
	STR_MY_WITHDRAWAL_REQUESTS,
	STR_MY_WITHDRAWALS,
	STR_NO_RECORD,
	STR_NOTIFICATIONS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_RECENT_CROPS,
	STR_RECENT_ITEMS,
	STR_RECENT_REQUESTS,
	STR_SEARCH_HERE,
	STR_SEND_WITHDRAWAL_REQUEST,
	STR_SUBMIT,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_SUCCESS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_VIEW_MORE,
	STR_WITHDRAWAL_ACCOUNT_NAME,
	STR_WITHDRAWAL_ACCOUNT_NUMBER,
	STR_WITHDRAWAL_AMOUNT,
	STR_WITHDRAWAL_METHOD
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdContactPage, MdInfoOutline, MdListAlt, MdOutlineMenu, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdSearch, MdSupportAgent, MdTranslate } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import login_bg from '../assets/login_bg.jpg';
import HomeMenu from "./HomeMenu";
import WelcomeSlider from '../ones/WelcomeSlider';
import OneOrder from "../ones/OneOrder";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);

	const [filter, setFilter] = useState("");

	const [amount, setAmount] = useState(0);
	const [withdrawalMethod, setWithdrawalMethod] = useState("Vodacom MPesa");
	const [withdrawalAccountName, setWithdrawalAccountName] = useState("");
	const [withdrawalAccountNumber, setWithdrawalAccountNumber] = useState("");

	const [loading, setLoading] = useState(false);


	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getMyAccountBalance(),
		])
		setReady(true);
	}

	async function withdraw() {
		if(!isNaN(Number(amount)) && Number(amount) >= 1000) {
			if(withdrawalMethod && withdrawalMethod.trim().length > 0) {
				if(withdrawalAccountName && withdrawalAccountName.trim().length > 0) {
					if(withdrawalAccountNumber && withdrawalAccountNumber.trim().length > 0) {
						setLoading(true);
						await callApi(
							'create-withdrawal-request',
							{
								amount,
								withdrawalAccountName,
								withdrawalAccountNumber,
								withdrawalMethod,
							}
						).then((response) => {
							if(response.status === 1) {
								appContext.tellMessage(STR_SUCCESS[appContext.language]);

								setAmount(0);
								setWithdrawalAccountName("");
								setWithdrawalAccountNumber("");
							} else {
								appContext.tellError(response.msg);
							}
						})
						setLoading(false);
					} else {
						appContext.tellError(STR_INVALID_WITHDAWAL_INFO[appContext.language]);
					}
				} else {
					appContext.tellError(STR_INVALID_WITHDAWAL_INFO[appContext.language]);
				}
			} else {
				appContext.tellError(STR_INVALID_WITHDAWAL_INFO[appContext.language]);
			}
		} else {
			appContext.tellError(STR_INVALID_WITHDAWAL_INFO[appContext.language]);
		}
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);
		
		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	if (ready) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
					paddingBottom: "calc(var(--topBarHeight) + 40px)",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">

						
						<div className="col-md-12">
							
							<h6 className="main-section-title">
								{STR_MY_REVENUES[appContext.language]} 
								
							</h6>
								
						</div>

						<div className="col-md-12">
							<div className="card">
								<div className="card-body">
									<h6 className="card-title">{STR_CURRENT_BALANCE[appContext.language]}</h6>
									<h6
										style={{
											fontSize: "32px"
										}}
									>
										{formatMoney(appContext.myAccountBalance)}
										<span
											style={{
												fontSize: "14px"
											}}
											className="d-block"
										>
											TZS
										</span>
									</h6>
								</div>
							</div>
						</div>

						<div className="col-md-6 mt-4 mb-4">
							
							<div
								className="d-flex bg-surface mb-2"
								style={{
									padding: "10px",
									cursor: "pointer",
									borderBottom: "2px solid var(--secondaryColor)"
								}}
								onClick={() => {
									appContext.navTo({
										item: 'my-withdrawal-requests',
									})
								}}
							>
								<MdListAlt className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
								<h6
									className="mNoMargin align-self-center font-semi-bold"
									style={{
										fontSize: "14px",
										paddingLeft: "20px",
									}}
								>
									{STR_MY_WITHDRAWAL_REQUESTS[appContext.language]}
								</h6>
							</div>

							<div
								className="d-flex bg-surface mb-2"
								style={{
									padding: "10px",
									cursor: "pointer",
									borderBottom: "2px solid var(--secondaryColor)"
								}}
								onClick={() => {
									appContext.navTo({
										item: 'my-withdrawals',
									})
								}}
							>
								<MdListAlt className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
								<h6
									className="mNoMargin align-self-center font-semi-bold"
									style={{
										fontSize: "14px",
										paddingLeft: "20px",
									}}
								>
									{STR_MY_WITHDRAWALS[appContext.language]}
								</h6>
							</div>

							<div
								className="d-flex bg-surface mb-2"
								style={{
									padding: "10px",
									cursor: "pointer",
									borderBottom: "2px solid var(--secondaryColor)"
								}}
								onClick={() => {
									appContext.navTo({
										item: 'my-revenue-history',
									})
								}}
							>
								<MdListAlt className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
								<h6
									className="mNoMargin align-self-center font-semi-bold"
									style={{
										fontSize: "14px",
										paddingLeft: "20px",
									}}
								>
									{STR_MY_EARNINGS_HISTORY[appContext.language]}
								</h6>
							</div>
							
							
						</div>


						<div className="col-md-6">
							<div className="card">
								<div className="card-body">
									<h6 className="card-title">{STR_SEND_WITHDRAWAL_REQUEST[appContext.language]}</h6>
									
									<div className="mt-3 mb-3">
										<label className="form-label">{STR_WITHDRAWAL_AMOUNT[appContext.language]} (TZS)</label>
										<input
											className="form-control"
											value={amount}
											onChange={(e) => setAmount(e.target.value)}
										/>
										<div className="form-text" style={{ fontSize: "14px" }}>
											Min: 1,000 TZS
										</div>
									</div>

									<div className="mt-3 mb-3">
										<label className="form-label">{STR_WITHDRAWAL_METHOD[appContext.language]}</label>
										<select
											className="form-control"
											value={withdrawalMethod}
											onChange={(e) => setWithdrawalMethod(e.target.value)}
										>
											<option value="Vodacom MPesa">Vodacom MPesa</option>
											<option value="Mixx By YAS">Mixx By YAS</option>
											<option value="HaloPesa">HaloPesa</option>
											<option value="Airtel Money">Airtel Money</option>
											<option value="CRDB Bank">CRDB Bank</option>
											<option value="NMB Bank">NMB Bank</option>
										</select>
									</div>

									<div className="mt-3 mb-3">
										<label className="form-label">{STR_WITHDRAWAL_ACCOUNT_NAME[appContext.language]}</label>
										<input
											className="form-control"
											value={withdrawalAccountName}
											onChange={(e) => setWithdrawalAccountName(e.target.value)}
										/>
									</div>

									<div className="mt-3 mb-3">
										<label className="form-label">{STR_WITHDRAWAL_ACCOUNT_NUMBER[appContext.language]}</label>
										<input
											className="form-control"
											value={withdrawalAccountNumber}
											onChange={(e) => setWithdrawalAccountNumber(e.target.value)}
										/>
									</div>

									<div className="mt-3 mb-3">
										<button
											className="btn btn-block btn-rounded btn-padded btn-primary"
											onClick={withdraw}
										>
											{STR_SUBMIT[appContext.language]}
										</button>
									</div>

								</div>
							</div>
						</div>

					</div>

					

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}